var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-col",
    { attrs: { "no-margin": "" } },
    [
      _vm._l(_vm.structure.columns, function (column, i) {
        return _c(
          "w-row",
          { key: i, staticClass: "grow" },
          [
            _c(
              "w-col",
              { attrs: { xs: "4" } },
              [
                _c("w-input", {
                  attrs: { label: "Kolom naam", fancy: "" },
                  model: {
                    value: column.name,
                    callback: function ($$v) {
                      _vm.$set(column, "name", $$v)
                    },
                    expression: "column.name",
                  },
                }),
              ],
              1
            ),
            _c(
              "w-col",
              { attrs: { xs: "3" } },
              [
                _c("w-select", {
                  attrs: { items: _vm.types, label: "Kolom type", fancy: "" },
                  model: {
                    value: column.type,
                    callback: function ($$v) {
                      _vm.$set(column, "type", $$v)
                    },
                    expression: "column.type",
                  },
                }),
              ],
              1
            ),
            _c(
              "w-col",
              { attrs: { grow: "", shrink: "", xs: "4" } },
              [
                _c("w-input", {
                  attrs: { label: "Vertaalde kolom naam", fancy: "" },
                  model: {
                    value: column.translatedName,
                    callback: function ($$v) {
                      _vm.$set(column, "translatedName", $$v)
                    },
                    expression: "column.translatedName",
                  },
                }),
              ],
              1
            ),
            _c(
              "w-col",
              { attrs: { grow: "", xs: "1", right: "" } },
              [
                _c(
                  "w-button",
                  {
                    attrs: { flat: "" },
                    on: {
                      click: function ($event) {
                        return _vm.remove(i)
                      },
                    },
                  },
                  [_c("w-fa", { attrs: { icon: "minus" } })],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      }),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c(
                "w-row",
                { attrs: { "no-margin": "" } },
                [
                  _c("w-spacer"),
                  _c(
                    "w-button",
                    {
                      attrs: { flat: "" },
                      on: {
                        click: function ($event) {
                          return _vm.add()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "plus" } })],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }